var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailStats = function SvgEmailStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".email-stats_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-stats_svg__b50f24f7-f949-4e6f-a7c5-c3a57de13b52",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-stats_svg__a4b5c18f-e1f9-42cc-83fc-fc62f713b9b6",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5 8.75 4 2.75V22a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 22V11.5l4-2.75",
    className: "email-stats_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 20.5 5-4h7l5 4M23.5 11.5l-6 4M.5 11.5l6 4M19.5 14.167V1.5a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1v12.667",
    className: "email-stats_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.823h.909v3.245H7zM8.818 7.119h.909v5.949h-.909zM10.636 8.742h.909v4.327h-.909zM12.454 4.956h.909v8.113h-.909zM14.273 7.119h.909v5.949h-.909zM16.091 2.792H17v10.276h-.909z",
    className: "email-stats_svg__st0"
  })))));
};
export default SvgEmailStats;